import React, { useEffect, useState } from "react";
import Layout from "../../../components/resusable/layout/layout";
import { useNavigate } from "react-router-dom";
import { dentalIcons } from "../../../dentail-indetifcation/utils-icons/dentalIcons";
import { Input, message } from "antd";
import CustomSearchInput from "../../../dentail-indetifcation/components/d-reusable/CustomSearchInput";
import CustomPrimaryButton from "../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import SingleProjectItem from "../../components/SingleProjectItem";
import { errorRequestHandel } from "../../../helper";
import CustomModal from "../../../age-assessment/components/modals/CustomModal";
import CustomDeleteButton from "../../../dentail-indetifcation/components/d-reusable/CustomDeleteButton";
import CustomButtonWithIcon from "../../../dentail-indetifcation/components/d-reusable/CustomButtonWithIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  _onCreateImageAnalysisProject,
  _onDeleteImageAnalysisProject,
  _onSetAllAnalysisProjects,
} from "../../../redux/actions/imaga-analysis/projectActions";
import {
  createAnalysisProject,
  deleteAnalysisProject,
  getAllAnalysisProjects,
} from "../../../components/https/image-analysis-apis";
import ProjectListShimmer from "../../components/shimer/ProjectListeShimer";
import { AppstoreOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { Calendar, Clock, Folder } from "lucide-react";
import moment from "moment";
import SingleProjectGridItem from "../../components/SingleProjectGridItem";
import { useSubscriptionGuard } from "../../../hooks/subscription-hook/UseSubscriptionGuard";

const ImageAnalysisProjects = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useSubscriptionGuard();
  const [showCreateProjectModal, setShowCreateProjectModal] = useState(false);
  const [projectTitle, setProjectTitle] = useState("");
  const [projectTitleError, setProjectTitleError] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [projectId, setProjectId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [query, setQuery] = useState("");

  const [viewMode, setViewMode] = useState("grid"); // 👈 default: grid

  const allProjects = useSelector((state) => state.analysis.projects || []);

  useEffect(() => {
    fetchAllAnalysisProject();
  }, [query]);

  const fetchAllAnalysisProject = async () => {
    try {
      setIsLoading(true);
      const response = await getAllAnalysisProjects({ search: query });
      if (response.status === 200) {
        const allProjectData = response.data.data || [];
        dispatch(_onSetAllAnalysisProjects(allProjectData));
        setIsLoading(false);
      }
    } catch (error) {
      errorRequestHandel({ error: error });
      setIsLoading(false);
    }
  };

  const onCreateNewProject = async () => {
    try {
      if (projectTitle === "" || projectTitle === undefined) {
        setProjectTitleError("Project name is required");
        return;
      }

      setLoading(true);
      const data = {
        ...(projectId != null ? { id: projectId } : {}),
        title: projectTitle,
        description: projectDescription,
      };

      const response = await createAnalysisProject({ payload: data });
      if (response.status === 200) {
        setShowCreateProjectModal(false);
        dispatch(_onCreateImageAnalysisProject(response.data.data));
        message.success(
          `Project has been ${projectId ? "updated" : "created"} successfully`
        );
        setProjectTitleError("");
        setProjectTitle("");
        setProjectDescription("");
        setProjectId(null);
        await fetchAllAnalysisProject();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  const onEditProject = (item) => {
    setProjectId(item?.id);
    setProjectTitle(item?.title);
    setProjectDescription(item?.description);
    setShowCreateProjectModal(true);
  };

  const handleProjectDelete = (id) => {
    setProjectId(id);
    setShowDeleteConfirmationModal(true);
  };

  const onDeleteProjectHandle = async () => {
    try {
      setLoading(true);
      const response = await deleteAnalysisProject({ id: projectId });
      if (response.status === 200) {
        setShowDeleteConfirmationModal(false);
        dispatch(_onDeleteImageAnalysisProject(projectId));
        message.success("Project has been deleted successfully");
        setLoading(false);
        setProjectId(null);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  const handleKeepProject = () => {
    setShowDeleteConfirmationModal(false);
    setProjectId(null);
  };

  const handleClose = () => {
    setProjectTitleError("");
    setProjectTitle("");
    setProjectDescription("");
    setProjectId(null);
    setShowCreateProjectModal(false);
  };

  return (
    <Layout>
      <div className="flex-1 max-w-[1200px] mx-auto px-4 md:px-6 lg:px-8">
        {/* Header */}
        <div className="image_analysis_container py-[50px] flex items-center gap-2 justify-between">
          <div>
            <h2>All Projects</h2>
            <p>Manage your radiograph analysis projects</p>
          </div>
          <div className="flex gap-2 items-center">
            {/* View Toggle Buttons */}
            <div className="flex bg-[#F5F6FA] rounded-lg overflow-hidden border border-[#E2E5EA]">
              <button
                onClick={() => setViewMode("grid")}
                className={`px-3 py-2 text-[18px] ${
                  viewMode === "grid"
                    ? "bg-[#20C3FF] text-white"
                    : "text-gray-500 hover:text-black"
                }`}
              >
                <AppstoreOutlined />
              </button>
              <button
                onClick={() => setViewMode("list")}
                className={`px-3 py-2 text-[18px] ${
                  viewMode === "list"
                    ? "bg-[#20C3FF] text-white"
                    : "text-gray-500 hover:text-black"
                }`}
              >
                <UnorderedListOutlined />
              </button>
            </div>

            {/* Search and Create */}
            <CustomSearchInput
              onSearch={(e) => setQuery(e)}
              search={query}
              onSearchEnter={() => null}
            />
            <CustomPrimaryButton
              title="New Project"
              width={180}
              isFirst={true}
              leadingIcon={true}
              icon={dentalIcons.plusButtonIcon}
              isRound={true}
              onClick={() => setShowCreateProjectModal(true)}
            />
          </div>
        </div>

        {/* Project Display */}
        {isloading ? (
          <ProjectListShimmer />
        ) : (
          <div>
            {allProjects.length > 0 ? (
              viewMode === "grid" ? (
                // 👇 GRID VIEW
                <div className="grid sm:grid-cols-2  md:grid-cols-2 lg:grid-cols-3  gap-3 mb-8">
                  {allProjects.map((item, index) => (
                    <React.Fragment key={index}>
                      <SingleProjectGridItem
                        item={item}
                        onClick={() =>
                          navigate(`/dental-analysis/projects/${item.id}`)
                        }
                        onDelete={() => handleProjectDelete(item.id)}
                        onEdit={() => onEditProject(item)}
                      />
                    </React.Fragment>
                  ))}
                </div>
              ) : (
                // 👇 LIST VIEW (unchanged)
                allProjects.map((item, index) => (
                  <React.Fragment key={index}>
                    <SingleProjectItem
                      item={item}
                      onClick={() =>
                        navigate(`/dental-analysis/projects/${item.id}`)
                      }
                      onDelete={() => handleProjectDelete(item?.id)}
                      onEdit={() => onEditProject(item)}
                    />
                  </React.Fragment>
                ))
              )
            ) : (
              <div className="flex flex-col items-center justify-center w-full h-[400px]">
                <p className="text-[16px] font-medium text-[#8F8F8F]">
                  No project created yet
                </p>
                <CustomButtonWithIcon
                  title="Create New Project"
                  onClick={() => setShowCreateProjectModal(true)}
                />
              </div>
            )}
          </div>
        )}
      </div>

      {/* Modals */}
      <CustomModal
        open={showCreateProjectModal}
        width={"30%"}
        onCancel={handleClose}
      >
        <div className="flex flex-col items-center justify-center space-y-3 p-3 pt-5">
          <img src={dentalIcons.newProjectIcon} alt="create project" />
          <h3>{projectId ? "Update Project" : "Create New Project"}</h3>
          <div className="h-[1.5px] bg-[#E1E4EA] w-full mt-4" />
          <div className="w-full space-y-2">
            <span className="text-[16px] text-[#28303F] font-medium">
              Project Name *
            </span>
            <Input
              placeholder="Enter project name"
              className="!rounded-[10px] !h-[48px]"
              value={projectTitle}
              onChange={(e) => setProjectTitle(e.target.value)}
              onFocus={() => setProjectTitleError("")}
            />
            {projectTitleError && (
              <span className="text-red-500 text-xs">{projectTitleError}</span>
            )}
          </div>
          <div className="w-full space-y-2">
            <span className="text-[16px] text-[#28303F] font-medium">
              Project Description
            </span>
            <Input.TextArea
              placeholder="Enter project description"
              value={projectDescription}
              onChange={(e) => setProjectDescription(e.target.value)}
              autoSize={{ minRows: 2, maxRows: 10 }}
              className="placeholder-gray-400 !rounded-[10px] !h-[108px] text-[#C2C2C2] font-medium"
            />
          </div>
          <div className="w-full pt-3">
            <CustomPrimaryButton
              title={projectId ? "Update" : "Create"}
              onClick={onCreateNewProject}
              width={"100%"}
              isRound
              isLoading={loading}
            />
          </div>
        </div>
      </CustomModal>

      {/* Delete Confirmation */}
      <CustomModal
        open={showDeleteConfirmationModal}
        width={"30%"}
        onCancel={() => setShowDeleteConfirmationModal(false)}
      >
        <div className="flex flex-col items-center justify-center space-y-3 p-3 pt-4">
          <img src={dentalIcons.deleteProjectIcon} alt="delete project" />
          <h3>Delete Project?</h3>
          <div className="h-[1.5px] bg-[#E1E4EA] w-full mt-4" />
          <p className="text-center text-[#8F8F8F] text-[16px] font-medium">
            Are you sure you want to delete this project? This action cannot be
            undone.
          </p>
          <div className="w-full pt-1 flex gap-3 items-center">
            <CustomButtonWithIcon
              title="No"
              onClick={handleKeepProject}
              width={"50%"}
              isRound
            />
            <CustomDeleteButton
              title="Yes, Delete"
              onClick={onDeleteProjectHandle}
              width={"50%"}
              isRound
              isLoading={loading}
            />
          </div>
        </div>
      </CustomModal>
    </Layout>
  );
};

export default ImageAnalysisProjects;
